var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "88 -844 671.559 712.62",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.1-131.38q-22.1 0-36.95-15.06-14.84-15.06-14.84-37.16 0-22.09 15.06-36.94 15.05-14.84 37.15-14.84t36.94 15.05q14.85 15.06 14.85 37.16 0 22.09-15.06 36.94t-37.15 14.85m407.38 0q-22.1 0-36.94-15.06-14.85-15.06-14.85-37.16 0-22.09 15.06-36.94 15.06-14.84 37.15-14.84 22.1 0 36.95 15.05 14.84 15.06 14.84 37.16 0 22.09-15.06 36.94-15.05 14.85-37.15 14.85M242.23-716 336-499.38h286.38q6.93 0 12.31-3.47 5.39-3.46 9.23-9.61l76.62-182q4.61-8.46.77-15-3.85-6.54-13.08-6.54zm-12.54-32h500.77q17.08 0 24.73 11.77 7.66 11.77 1.89 25.31L673.4-500.76q-6.32 14.76-19.21 24.07-12.88 9.31-29.5 9.31H317l-46.62 81.23q-6.15 9.23-.38 20t17.31 10.77h448.38v32H288.31q-33 0-47.73-26.16-14.73-26.15 1.65-52.61l58.15-99.23L166.31-812H88v-32h100.69zM336-499.38h301z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.9c154a1b8b98b91d353d03e58235be97.svg";
export { ForwardRef as ReactComponent };